import { render } from "./SubNav.vue?vue&type=template&id=6970a939"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import "./SubNav.vue?vue&type=style&index=0&id=6970a939&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__